/**
 * @fileoverview PUT handler for the "/:app_group_id/campaign_brief/:campaign_id" endpoint.
 * Uploads the brief file as multipart/form-data, replacing any existing brief.
 */
import fetch from "@lib/fetch";

import type { PutBriefResultErrors } from "../briefShared";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { campaignBriefCacheKeys } from "./constants";
import type { PutCampaignBriefProps, PutCampaignBriefResult } from "./types";

export const putCampaignBrief = reactQueryMutationAdapter(
  campaignBriefCacheKeys,
  createMutationFetcherFunctionWithShadowError<PutBriefResultErrors>()(
    (props: PutCampaignBriefProps): Promise<PutCampaignBriefResult> => {
      const body = new FormData();
      body.append("brief_file", props.briefFile);

      return fetch(
        `/${props.appGroupId}/campaign_brief/${props.campaignId}`,
        "PUT",
        {},
        { body },
        { setContentType: false, propagateFetchRequestError: false }
      );
    }
  )
);
